import { useMap, useMapEvents } from 'react-leaflet';
import { LatLngExpression } from 'leaflet';

const defaultPosition = [47.162494, 19.503304];

export function SavePositionComponent() {
  const map = useMap();

  useMapEvents({
    zoomend: () => {
      if (map?.getZoom()) {
        localStorage.setItem('zoom', String(map.getZoom()));
      }
    },
    moveend: () => {
      if (map?.getCenter()) {
        localStorage.setItem('center', JSON.stringify(map.getCenter()));
      }
    },
  });

  return null;
}

// false positive warning ???
// eslint-disable-next-line
export function loadSavedPosition(): [number, LatLngExpression] {
  // ez legyen useeffect, usestate ??
  const zoom = parseInt(localStorage.getItem('zoom') ?? '7');
  let center;
  const savedCenter = localStorage.getItem('center');
  if (savedCenter) {
    try {
      center = JSON.parse(savedCenter);
      // TODO ellenorizzuk, hogy jo-e ??
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_e) {
      localStorage.removeItem('center');
      center = defaultPosition;
    }
  } else {
    center = defaultPosition;
  }

  return [zoom, center];
}
